"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("@airasia/phoenix-components/components/CarrierLogo/constant");

var _constant3 = require("@airasia/phoenix-components/components/JourneySegment/constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    carrierSize: _propTypes.default.string,
    stopoverSize: _propTypes.default.string,
    virtualInterlining: _propTypes.default.bool,
    journeys: _propTypes.default.shape({
      carriers: _propTypes.default.arrayOf(_propTypes.default.shape({
        name: _propTypes.default.string,
        type: _propTypes.default.string,
        code: _propTypes.default.string,
        image: _propTypes.default.string
      })),
      designator: _propTypes.default.shape({
        departureStation: _propTypes.default.string,
        arrivalStation: _propTypes.default.string,
        departureTime: _propTypes.default.string,
        arrivalTime: _propTypes.default.string
      }),
      segments: _propTypes.default.arrayOf(_propTypes.default.shape({
        designator: _propTypes.default.shape({
          departureStation: _propTypes.default.string,
          arrivalStation: _propTypes.default.string,
          departureTime: _propTypes.default.string,
          arrivalTime: _propTypes.default.string
        }),
        duration: _propTypes.default.number,
        layoverTime: _propTypes.default.number
      })),
      subjectToGovtApproval: _propTypes.default.bool
    }),
    tripType: _propTypes.default.string,
    handleClick: _propTypes.default.func.isRequired,
    handleViewClick: _propTypes.default.func,
    customGuestText: _propTypes.default.string,
    customDetailText: _propTypes.default.string,
    locale: _propTypes.default.string,
    translation: _propTypes.default.shape({
      stopAt: _propTypes.default.string,
      hour: _propTypes.default.string,
      minute: _propTypes.default.string,
      depart: _propTypes.default.string,
      return: _propTypes.default.string,
      nonStop: _propTypes.default.string,
      singleStop: _propTypes.default.string,
      multiStop: _propTypes.default.string,
      ctaText: _propTypes.default.string,
      guest: _propTypes.default.string,
      details: _propTypes.default.string,
      subjectToGovtApproval: _propTypes.default.string
    }),
    price: _propTypes.default.shape({
      amount: _propTypes.default.number.isRequired,
      currency: _propTypes.default.string.isRequired
    }).isRequired,
    guest: _propTypes.default.number,
    loading: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    defaultDisabledFeatures: _propTypes.default.bool,
    showBaggageAllowance: _propTypes.default.bool,
    baggageDataList: _propTypes.default.array,
    hasNoCheckedBaggage: _propTypes.default.bool,
    hasNoCheckedBaggageOnly: _propTypes.default.bool,
    journeyDetailsJourneys: _propTypes.default.arrayOf(_propTypes.default.shape({
      designator: _propTypes.default.shape({
        departureStation: _propTypes.default.string,
        arrivalStation: _propTypes.default.string,
        arrivalAirport: _propTypes.default.string,
        departureAirport: _propTypes.default.string,
        departureTime: _propTypes.default.string,
        arrivalTime: _propTypes.default.string
      }),
      segment: _propTypes.default.shape({
        carrier: _propTypes.default.shape({
          name: _propTypes.default.string,
          type: _propTypes.default.string,
          code: _propTypes.default.string,
          flightNumber: _propTypes.default.number,
          image: _propTypes.default.string,
          cabinClass: _propTypes.default.string
        }),
        designator: _propTypes.default.shape({
          departureStation: _propTypes.default.string,
          arrivalStation: _propTypes.default.string,
          arrivalAirport: _propTypes.default.string,
          departureAirport: _propTypes.default.string,
          departureTime: _propTypes.default.string,
          arrivalTime: _propTypes.default.string
        }),
        isProtected: _propTypes.default.bool,
        isSelfTransfer: _propTypes.default.bool,
        isStopover: _propTypes.default.bool,
        isLast: _propTypes.default.bool,
        protectedBy: _propTypes.default.string,
        protectedByAction: _propTypes.default.func,
        selfTransferAction: _propTypes.default.func,
        duration: _propTypes.default.number,
        layoverTime: _propTypes.default.number,
        isTechnicalStop: _propTypes.default.bool,
        technicalStopLabel: _propTypes.default.string
      })
    })),
    journeyDetailsTranslation: _propTypes.default.shape({
      depart: _propTypes.default.string,
      return: _propTypes.default.string,
      flightDetailsHeader: _propTypes.default.string,
      hour: _propTypes.default.string,
      minute: _propTypes.default.string,
      economy: _propTypes.default.string,
      premium: _propTypes.default.string,
      business: _propTypes.default.string,
      first: _propTypes.default.string,
      layover: _propTypes.default.string,
      selfTransfer: _propTypes.default.string,
      protectionByStr: _propTypes.default.string,
      carrier: _propTypes.default.string,
      title: _propTypes.default.string,
      content: _propTypes.default.string,
      perGuest: _propTypes.default.string,
      noCheckedBaggage: _propTypes.default.string
    }),
    isSelected: _propTypes.default.bool,
    hasBoxShadow: _propTypes.default.bool,
    hasPadding: _propTypes.default.bool,
    ctaTextActionColor: _propTypes.default.string,
    ctaHorizontal: _propTypes.default.bool,
    ctaViewIconFirst: _propTypes.default.bool,
    ctaViewIcon: _propTypes.default.bool,
    ctaInlineDetails: _propTypes.default.bool,
    showFlightDetails: _propTypes.default.bool,
    customEvent: _propTypes.default.func,
    ctaShowButton: _propTypes.default.bool,
    ctaPosition: _propTypes.default.string,
    isBestDeal: _propTypes.default.bool,
    bundleType: _propTypes.default.string,
    showBundleType: _propTypes.default.bool,
    tagsList: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      redirectLink: _propTypes.default.string
    })),
    isMobile: false,
    strikethroughPrice: _propTypes.default.number,
    percentageDiscount: _propTypes.default.number,
    customPercentageDiscountText: _propTypes.default.string,
    useLocalTimezone: _propTypes.default.bool,
    promoTags: _propTypes.default.arrayOf(_propTypes.default.string),
    showStackedImages: _propTypes.default.bool,
    isAirasiaPlus: _propTypes.default.bool,
    onPressAirasiaPlus: _propTypes.default.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    journeys: [],
    tripType: _constant3.TRIP_TYPES.oneway,
    carrierSize: _constant2.SIZES.SMALL,
    stopoverSize: _constant2.SIZES.SMALL,
    locale: 'en-gb',
    handleClick: function handleClick() {},
    handleViewClick: function handleViewClick() {},
    customGuestText: null,
    customDetailText: null,
    loading: false,
    disabled: false,
    defaultDisabledFeatures: false,
    translation: {},
    showBaggageAllowance: false,
    baggageDataList: [],
    hasNoCheckedBaggage: false,
    ctaTextActionColor: 'tertiaryRed',
    hasNoCheckedBaggageOnly: false,
    journeyDetailsJourneys: [],
    journeyDetailsTranslation: {
      depart: 'Depart',
      return: 'Return',
      flightDetailsHeader: 'Flight details',
      hour: 'h',
      minute: 'm',
      economy: 'Economy',
      premium: 'Premium economy',
      business: 'Business',
      first: 'First',
      layover: 'Layover',
      selfTransfer: 'Self-transfer via {0}',
      protectionByStr: 'Connection protected by {0}',
      carrier: 'Kiwi.com Guarantee',
      title: 'Baggage Allowance',
      content: "Here's how much each guest can carry on every flight",
      perGuest: 'per guest',
      noCheckedBaggage: 'This is a no checked baggage flight'
    },
    isSelected: false,
    hasBoxShadow: true,
    hasPadding: true,
    showFlightDetails: true,
    customEvent: function customEvent() {},
    ctaShowButton: true,
    ctaPosition: 'center',
    isBestDeal: false,
    showBundleType: false,
    tagsList: [],
    isMobile: false,
    useLocalTimezone: false,
    showStackedImages: false,
    showCurrency: true,
    isAirasiaPlus: false,
    onPressAirasiaPlus: function onPressAirasiaPlus() {}
  }
};
exports.default = _default;